import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
// import { WorkOrderService } from "../../../services/index";

// import * as fromRootStore from "../../../reducers";
import { JobWorkService } from "../../../services/index";
// import { fusing } from "../factory/fusing/fusing";
// import { fusingPrint } from "./fusingPrint/fusingPrint";
// import { frPrint } from "./frPrint/frPrint";
// import { stitchingPrint } from "./stitchingPrint/stitchingPrint";
// import { kbPrint } from "./kbPrint/kbPrint";

declare var google;

@Component({
  selector: "production-store",
  templateUrl: "jobProductionStore.html",
})
export class jobProductionStore implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  showIssue: boolean = true;
  showApprove: boolean = true;
  isLoading: boolean = false;
  isLoadMask: Promise<any>;
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  saveEvent: any;
  selected = [];
  selectedWoNo: any;
  filter = {
    groupby: "department",
    department: "",
    cu_no: "",
    cp_date: "",
    unit_name: "",
  };
  total_wo: number;
  no_of_pcs: number;
  ac_qty: number;
  wo_qty: number;
  statusList = ["UNAPPROVED", "APPROVED"];
  page = {
    limit: 100,
    count: 0,
    offset: 0,
    orderBy: "keyValue",
    orderDir: "ASC",
  };

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("approveTemplate") approveTemplate;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;

  columns = [];
  toggleCol = [];
  menu: any;
  reportName = "design_no";
  reportType = "Design";
  user: any;
  agentVisible: boolean = false;
  companyInfo: any = [];
  orderList: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    public datePipe: DatePipe,
    private woservice: JobWorkService,
    public toasterService: ToasterService,
    private modalService: BsModalService
  ) {}

  ngOnInit(): void {
    this.getColumns();
    this.toggleCol = Object.assign({}, this.columns);
  }

  getColumns() {
    if (this.filter.groupby == "wo_id") {
      this.columns = [
        {
          prop: "selected",
          name: "",
          sortable: false,
          canAutoResize: false,
          draggable: false,
          resizable: false,
          headerCheckboxable: true,
          checkboxable: true,
          width: 30,
        },
        {
          name: "SNo",
          prop: "sno",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
          headerClass: "text-center",
          sortable: false,
          cellTemplate: this.snoTemplate,
          toggle: true,
          cellClass: "text-center",
        },
        {
          name: "Wo.no",
          prop: "wo_no",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Wo.Date",
          prop: "work_date",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 120,
          maxWidth: 120,
          width: 120,
        },
        {
          name: "Dc.no",
          prop: "dc_no",
          headerClass: "text-center",
          minWidth: 60,
          maxWidth: 60,
          width: 60,
        },
        {
          name: "Fab Design",
          prop: "fab_design",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 120,
          maxWidth: 120,
          width: 120,
        },
        {
          name: "Shirt DNo",
          prop: "shirt_design_no",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 120,
          maxWidth: 120,
          width: 120,
        },
        {
          name: "Cutting ratio",
          prop: "cutting_ratio",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 90,
          maxWidth: 90,
          width: 90,
        },
        {
          name: "No.of.Color",
          prop: "no_of_colors",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 70,
          maxWidth: 70,
          width: 70,
        },
        {
          name: "No.of.Pcs",
          prop: "tot_lumps",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 70,
          maxWidth: 70,
          width: 70,
        },
        {
          name: "Width",
          prop: "width",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 70,
          maxWidth: 70,
          width: 70,
        },
        {
          name: "Fab.Style",
          prop: "fab_style",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 120,
          maxWidth: 120,
          width: 120,
        },
        {
          name: "Shirt.style",
          prop: "style",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },

        {
          name: "Brand",
          prop: "brand",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Wo.Qty",
          prop: "wo_qty",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Ac.QTy",
          prop: "ac_qty",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Status",
          prop: "stage_status",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 100,
          maxWidth: 100,
          width: 100,
        },
      ];
    } else if (this.filter.groupby == "cu_no") {
      this.columns = [
        {
          name: "SNo",
          prop: "sno",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
          headerClass: "text-center",
          sortable: false,
          cellTemplate: this.snoTemplate,
          toggle: true,
          cellClass: "text-center",
        },
        {
          name: "Cu.No",
          prop: "cu_no",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Cu.Date",
          prop: "cp_date",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 125,
          maxWidth: 125,
          width: 125,
        },
        {
          name: "C.P No",
          prop: "ff_cp_no",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "FF.Date",
          prop: "ff_date",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 125,
          maxWidth: 125,
          width: 125,
        },

        {
          name: "Cutting ratio",
          prop: "cutting_ratio",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 90,
          maxWidth: 90,
          width: 90,
        },
        {
          name: "No.of.WO",
          prop: "no_of_wo",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "No.of.Pcs",
          prop: "tot_lumps",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Width",
          prop: "width",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Fab.Style",
          prop: "fab_style",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 120,
          maxWidth: 120,
          width: 120,
        },
        {
          name: "Fab.type",
          prop: "fab_type",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Shirt.style",
          prop: "style",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Brand",
          prop: "brand",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Tot.Mtrs",
          prop: "tot_mtrs",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Wo.Qty",
          prop: "wo_qty",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Ac.QTy",
          prop: "ac_qty",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },

        {
          name: "Action",
          prop: "sno",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
          sortable: false,
          cellTemplate: this.editDeleteTemplate,
        },
      ];
    }else if(this.filter.groupby == "unit"){
      this.columns = [
        {
          name: "SNo",
          prop: "sno",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
          headerClass: "text-center",
          sortable: false,
          cellTemplate: this.snoTemplate,
          toggle: true,
          cellClass: "text-center",
        },
        {
          name: "Unit Name",
          prop: "unit_name",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 200,
          maxWidth: 200,
          width: 200,
        },
        {
          name: "No.of.WO",
          prop: "no_of_wo",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "No.of.Pcs",
          prop: "tot_lumps",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Wo.Qty",
          prop: "wo_qty",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Ac.QTy",
          prop: "ac_qty",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Action",
          prop: "sno",
          minWidth: 100,
          maxWidth: 120,
          width: 110,
          sortable: false,
          cellTemplate: this.editDeleteTemplate,
        },
      ];
    } else {
      this.columns = [
        {
          name: "SNo",
          prop: "sno",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
          headerClass: "text-center",
          sortable: false,
          cellTemplate: this.snoTemplate,
          toggle: true,
          cellClass: "text-center",
        },
        {
          name: "Department",
          prop: "department",
          cellClass: "text-center",
          headerClass: "text-center",
          minWidth: 200,
          maxWidth: 200,
          width: 200,
        },
        {
          name: "No.of.WO",
          prop: "no_of_wo",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "No.of.Pcs",
          prop: "tot_lumps",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Wo.Qty",
          prop: "wo_qty",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Ac.QTy",
          prop: "ac_qty",
          headerClass: "text-center",
          cellClass: "text-center",
          minWidth: 80,
          maxWidth: 80,
          width: 80,
        },
        {
          name: "Action",
          prop: "sno",
          minWidth: 100,
          maxWidth: 120,
          width: 110,
          sortable: false,
          cellTemplate: this.editDeleteTemplate,
        },
      ];
    }

    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#party_code").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
    //this.getSalesinvReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getOrderList();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    this.getOrderList();
  }

  clearFilter(): void {
    this.filter = {
      groupby: "department",
      department: "",
      cu_no: "",
      cp_date: "",
      unit_name: "",
    };
    this.applyFilter();
  }

  applyFilter(): void {
    this.getColumns();
  }
  viewDepartmentWo(row) {
    if (this.filter.groupby == "cu_no") {
      this.page.orderBy = "cu_no";
      this.page.orderDir = "DESC";
      this.filter.department = row.department;
      this.filter.groupby = "wo_id";
      this.filter.cu_no = row.cu_no;
      this.filter.cp_date = row.cp_date;
    }

    if (this.filter.groupby == "department") {
      this.page.orderBy = "wo_id";
      this.page.orderDir = "DESC";
      this.filter.department = row.department;
      
    }

    if (this.filter.department == "UNAPPROVED STITCHING" && (this.filter.groupby == "unit" || this.filter.groupby == "department")) {
      if (this.filter.groupby == "unit") {
        this.filter.unit_name = row.unit_name;
        this.filter.groupby = "cu_no";
      } else if (this.filter.groupby == "department") {
        this.filter.groupby = "unit";
      }
    }else if(this.filter.groupby == "department"){
      this.filter.groupby = "cu_no";
    }

    this.getColumns();
  }
  gobacktoCpGroup() {
    if (this.filter.department == "UNAPPROVED STITCHING") {
      if (this.filter.groupby == "unit") {
        this.page.orderBy = "keyValue";
        this.page.orderDir = "ASC";
        this.filter.department = "";
        this.filter.groupby = "department";
      }
      if (this.filter.groupby == "cu_no") {
        this.filter.groupby = "unit";
        this.filter.unit_name = "";
      }
    } else {
      if (this.filter.groupby == "cu_no") {
        this.page.orderBy = "keyValue";
        this.page.orderDir = "ASC";
        this.filter.department = "";
        this.filter.groupby = "department";
      }
    }
    if (this.filter.groupby == "wo_id") {
      this.page.orderBy = "cu_no";
      this.page.orderDir = "DESC";

      if (this.selected.length > 0) {
        swal("Please deselect all before going back");
        return;
      }

      this.filter.groupby = "cu_no";
      this.filter.cu_no = "";
      this.filter.cp_date = "";
    }

    this.getColumns();
  }
  getOrderList(): void {
    let params = {
      start: `${this.page.offset * this.page.limit}`,
      limit: `${this.page.limit}`,
      page: "1",
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
    };

    params["filter"] = JSON.stringify(this.filter);
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.woservice
      .getProductionStore(params)
      .then(function (res: any) {
        that.page.count = res.totCnt;
        that.orderList = res.data;

        if (that.filter.groupby == "department") {
          let departments = [
            "UNAPPROVED AC",
            "UNAPPROVED FUSING",
            "UNAPPROVED F & R",
            "UNAPPROVED STITCHING",
            "UNAPPROVED K & B",
          ];

          departments.forEach((el1, index) => {
            let exist = that.orderList.findIndex((el) => el.department == el1);
            if (exist == -1) {
              that.addDept(el1, index);
            }
          });
          that.orderList = that.orderList.sort(function (a, b) {
            return (
              departments.indexOf(a.department) -
              departments.indexOf(b.department)
            );
          });
          
          res.data = that.orderList;
          res.totCnt = that.orderList.length;

         
        }
        that.total_wo = 0;
          that.no_of_pcs = 0;
          that.wo_qty = 0;
          that.ac_qty = 0;
          that.orderList.forEach((el) => {
            that.no_of_pcs += el.tot_lumps;
            that.total_wo += el.no_of_wo;
            that.wo_qty += el.wo_qty;
            that.ac_qty += el.ac_qty;
          });
        that.no_of_pcs =
          Math.round((that.no_of_pcs + Number.EPSILON) * 100) / 100;
        that.total_wo =
          Math.round((that.total_wo + Number.EPSILON) * 100) / 100;
        that.wo_qty = Math.round((that.wo_qty + Number.EPSILON) * 100) / 100;
        that.ac_qty = Math.round((that.ac_qty + Number.EPSILON) * 100) / 100;

        that.loadingIndicator = false;
        that.page.count = res.totCnt;
        that.orderList = res.data;
      });
  }
  addDept(dept, index) {
    let deptmnt = {
      department: dept,
      no_of_wo: 0,
      tot_lumps: 0,
      wo_qty: 0,
      ac_qty: 0,
    };
    this.orderList.splice(index, 0, deptmnt);
  }
  // approveProductionStore(row) {
  //   let that = this;
  //   let dept = (that.filter.department == 'UNAPPROVED AC')?'CUTTING':(that.filter.department == 'UNAPPROVED FUSING')?'FUSING':(that.filter.department == 'UNAPPROVED F & R')?'FRONT & RECUTTING':(that.filter.department == 'UNAPPROVED STITCHING')?'STITCHING':'K & B';
  //   swal({
  //     title:
  //       "ARE YOU SURE TO APPROVE " + dept + " (" + row["wo_no"] + ") ?",
  //     html:
  //       '<input type = "text" id="approver" class="swal2-input" placeholder = "APPROVER">',
  //     type: "warning",
  //     showCancelButton: true,
  //     confirmButtonText: "Yes, Approve it!",
  //     cancelButtonText: "Cancel",
  //   }).then(
  //     function () {
  //       if (
  //         (<HTMLInputElement>document.getElementById("approver")).value != ""
  //       ) {
  //         let params = {
  //           wo_id: row.wo_id,
  //           department: that.filter.department,
  //           approver: (<HTMLInputElement>document.getElementById("approver"))
  //             .value,
  //         };
  //         that.isLoadMask = that.woservice
  //           .approveProductionStore(params)
  //           .then((res: any) => {
  //             if (res.success) {
  //               swal("Approved Successfully");

  //             }else{
  //               swal("SOMETHING WENT WRONG");
  //             }
  //             that.getOrderList();
  //           });
  //       } else {
  //         swal("PLEASE ENTER APPROVER NAME");
  //       }
  //     },
  //     function (dismiss) {}
  //   );
  // }

  onSelect({ selected }) {
    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);

    let selectedStatus = this.selected[0].stage_status;

    let showButton = this.selected.every((el) => {
      return selectedStatus == el.stage_status;
    });

    if (this.filter.department == "UNAPPROVED AC") {
      if (showButton) {
        if (selectedStatus == "APPROVED") {
          this.showIssue = false;
          this.showApprove = true;
        } else if (selectedStatus == "UNAPPROVED") {
          this.showIssue = true;
          this.showApprove = false;
        }
      } else {
        this.showIssue = true;
        this.showApprove = true;
      }
    }

    if (this.filter.department == "UNAPPROVED FUSING") {
      if (showButton) {
        if (selectedStatus == "APPROVED") {
          this.showIssue = false;
          this.showApprove = true;
        } else if (selectedStatus == "UNAPPROVED") {
          this.showIssue = true;
          this.showApprove = false;
        }
      } else {
        this.showIssue = true;
        this.showApprove = true;
      }
    }
    if (this.filter.department == "UNAPPROVED F & R") {
      if (showButton) {
        if (selectedStatus == "APPROVED") {
          this.showIssue = false;
          this.showApprove = true;
        } else if (selectedStatus == "UNAPPROVED") {
          this.showIssue = true;
          this.showApprove = false;
        }
      } else {
        this.showIssue = true;
        this.showApprove = true;
      }
    }
    if (this.filter.department == "UNAPPROVED STITCHING") {
      if (showButton) {
        if (selectedStatus == "APPROVED") {
          this.showIssue = false;
          this.showApprove = true;
        } else if (selectedStatus == "UNAPPROVED") {
          this.showIssue = true;
          this.showApprove = false;
        }
      } else {
        this.showIssue = true;
        this.showApprove = true;
      }
    }
    if (this.filter.department == "UNAPPROVED K & B") {
      if (showButton) {
        if (selectedStatus == "APPROVED") {
          this.showIssue = false;
          this.showApprove = true;
        } else if (selectedStatus == "UNAPPROVED") {
          this.showIssue = true;
          this.showApprove = false;
        }
      } else {
        this.showIssue = true;
        this.showApprove = true;
      }
    }

    console.log(this.selected);
  }

  getId(row) {
    return row.wo_id;
  }

  getIdFunction() {
    return this.getId.bind(this);
  }

  displayCheck(row) {
    if (row.department == "UNAPPROVED AC") {
      return row.fusing_id == null;
    }
    if (row.department == "UNAPPROVED FUSING") {
      return row.fr_id == null;
    }
    if (row.department == "UNAPPROVED F & R") {
      return row.stitching_id == null;
    }
    if (row.department == "UNAPPROVED STITCHING") {
      return row.kb_id == null;
    }
    // whatto do for kb
    if (row.department == "UNAPPROVED K & B") {
      return row.issue_status != 'ISSUED';
    }
  }

  onApproveAc(type) {
    if (this.selected.length > 0) {
      let that = this;
      let dept =
        that.filter.department == "UNAPPROVED AC"
          ? "Cutting"
          : that.filter.department == "UNAPPROVED FUSING"
          ? "Fusing"
          : that.filter.department == "UNAPPROVED F & R"
          ? "Front & Recutting"
          : that.filter.department == "UNAPPROVED STITCHING"
          ? "Stitching"
          : "K & B";
          let deptPrint =
        that.filter.department == "UNAPPROVED AC"
          ? "Fusing"
          : that.filter.department == "UNAPPROVED FUSING"
          ? "Front & Recutting"
          : that.filter.department == "UNAPPROVED F & R"
          ? "Stitching"
          : that.filter.department == "UNAPPROVED STITCHING"
          ? "Kaja & Button"
          : '';
      this.selectedWoNo = [];
      this.selectedWoNo = this.selected.map((el) => el.wo_id);

      swal({
        title: "Are you sure to " + type + " " + dept,
        html:
          that.filter.department == "UNAPPROVED F & R"
            ? '<div style = "display : flex;"><input style = "width : 45%" type = "text" id="approver" class="swal2-input" placeholder = "APPROVER"><input style = "width: 45%;height: 50%;padding: 9px;margin: 20px 0;border: 1px solid #8882825c;" type="text"  placeholder = "UNIT NAME" id = "unit_name" name="unit_name" list="unitList"><datalist id="unitList"><option value="SKM"><option value="VPM"></datalist></div>'
            : '<input type = "text" id="approver" class="swal2-input" placeholder = "APPROVER">',
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, " + type + " it!",
        cancelButtonText: "Cancel",
      }).then(
        // function () {
        //   if (
        //     (<HTMLInputElement>document.getElementById("approver")).value != ""
        //   ) {
        //     let params = {
        //       department: that.filter.department,
        //       approver: (<HTMLInputElement>document.getElementById("approver"))
        //         .value,
        //       selectedWoNo: JSON.stringify(that.selectedWoNo),
        //       type: type,
        //     };
        //     if (that.filter.department == "UNAPPROVED F & R") {
        //       params["unit_name"] = (<HTMLInputElement>(
        //         document.getElementById("unit_name")
        //       )).value;

        //       if (
        //         (<HTMLInputElement>document.getElementById("unit_name"))
        //           .value == ""
        //       ) {
        //         swal("PLEASE SELECT UNIT NAME");
        //         return;
        //       }
        //     }
        //     that.isLoadMask = that.woservice
        //       .approveProductionStore(params)
        //       .then((res: any) => {
        //         if (res.success) {
        //           swal("APPROVED SUCCESSFULLY");
        //         // if(type == 'issue' && that.filter.department != "UNAPPROVED K & B"){
        //         //   setTimeout(()=>{
        //         //     swal({
        //         //       title: "Do you need a print for " + deptPrint +   "?",
        //         //       type: "warning",
        //         //       showCancelButton: true,
        //         //       confirmButtonText: "Yes, Print!",
        //         //       cancelButtonText: "No"
        //         //     }).then(()=>{
        //         //       that.print(that.selectedWoNo,deptPrint);
        //         //     });
        //         //   },2000);

        //         // }
                
        //           const tabObj1 = {
        //             action: "CloseTab",
        //             params: {},
        //           };
        //           that.tabUpdateEvent.emit(tabObj1);

        //           let tabObj = {
        //             action: "NewTab",
        //             params: {
        //               tabName: "PRODUCTION STORE",
        //               title: "PRODUCTION STORE",
        //               tabParent: "WORK ORDERS",
        //               name: "PRODUCTION STORE",
        //             },
        //           };
        //           that.tabUpdateEvent.emit(tabObj);
        //         } else {
        //           swal("SOMETHING WENT WRONG");
        //         }
        //         that.getOrderList();
        //       });
        //   } else {
        //     swal("PLEASE ENTER APPROVER NAME");
        //   }
        // },
        function (dismiss) {}
      );
    } else {
      swal("SELECT ATLEAST ONE WO.NO");
    }
  }
  bsModalRef: BsModalRef;
  // print(row,dept) {

  //   let printComponent;

  //   if(dept == 'Fusing'){
  //      this.bsModalRef = this.modalService.show(fusingPrint, {
  //     keyboard: false,
  //     ignoreBackdropClick: true,
  //     class: "modal-lg compWidth-96"
  //   });
  //   }else if(dept == 'Front & Recutting'){
  //     this.bsModalRef = this.modalService.show(frPrint, {
  //       keyboard: false,
  //       ignoreBackdropClick: true,
  //       class: "modal-lg compWidth-96"
  //     });
  //   }else if(dept == 'Stitching'){
  //      this.bsModalRef = this.modalService.show(stitchingPrint, {
  //       keyboard: false,
  //       ignoreBackdropClick: true,
  //       class: "modal-lg compWidth-96"
  //     });
  //   }else{
  //      this.bsModalRef = this.modalService.show(kbPrint, {
  //       keyboard: false,
  //       ignoreBackdropClick: true,
  //       class: "modal-lg compWidth-96"
  //     });
  //   }

   
  //   this.bsModalRef.content.printdt = Object.assign({}, row);
  //   // this.bsModalRef.content.printcontent = this.printData;
  // }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/jobworkorder/jobProductionStore.ts